export enum StatusTemplateEnum {
  PENDING = 'Pendente',
  IN_REVIEW = 'Em revisão',
  APPROVED = 'Aprovado',
  REJECTED = 'Rejeitado',
  PAUSED = 'Pausado',
  DISABLED = 'Desabilitado',
  DELETED = 'Deleteado'
}
